import { FaXmark } from "react-icons/fa6";
import { MdErrorOutline } from "react-icons/md";
const CustomModal = ({
  bodycontent,
  children,
  showModal,
  show,
  type = "Error",
  title,
  closeModal,
  onClose,
  size,
}) => {
  const isShown = showModal || show;
  const handleClose = closeModal || onClose;
  const content = bodycontent || children;

  if (!isShown) return <></>;

  const maxWidthClass = size === "md" ? "min-w-[50vw]" : size === "lg" ? "min-w-[70vw]" : "min-w-[40vw]";

  return (
    <div className="z-[999] fixed bg-[#00000080] top-0 bottom-0 flex items-center justify-center left-0 right-0 backdrop-blur-sm px-4">
      <div className={`relative bg-white p-6 rounded-2xl ${maxWidthClass} max-h-[85vh] overflow-auto shadow-2xl transition-all`}>
        <div className="flex items-center justify-between mb-4">
          <h6 className="text-xl font-black text-gray-800 flex items-center gap-x-2">
            {type === "error" && <MdErrorOutline className="text-red-500" />}
            {title || type.toUpperCase()}
          </h6>
          <FaXmark
            className="text-xl text-gray-400 hover:text-red-500 cursor-pointer transition-colors"
            onClick={() => handleClose ? handleClose() : null}
          />
        </div>
        <div className="h-px bg-gray-100 w-full mb-5" />
        {content}
      </div>
    </div>
  );
};

export default CustomModal;
